// initialize cookie consent
patternlab.Util.ready(() => {
    patternlab.CookieConsent.init();

    cookieConsentSearchElement();
});

function cookieConsentSearchElement() {
    const searchElement = document.querySelector('.js-global-search');

    if (searchElement) {
        const status = getCookieConsentStatus();

        if (status === 'deny') {
            // Cookies abgelehnt > sichtbar & Klick zeigt Cookie-Banner
            searchElement.addEventListener('click', () => {
                if (window.cookieconsent) {
                    const banner = document.querySelector('.cc-window'); // Banner-Container
                    if (banner) {
                        banner.style.display = 'flex';
                        banner.classList.remove('cc-invisible');
                    }
                }
            });
        }
    }
}

function getCookieConsentStatus() {
    const match = document.cookie.match(/(^|;\s*)cookieconsent_status=([^;]*)/);
    return match ? decodeURIComponent(match[2]) : null;
}
